// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"13":"4ffbae63","229":"42dc9e47","370":"68aaf7c6","409":"80d0b85f","477":"9fb216ba","768":"fb17af86","856":"bfcbd804","872":"13832e15"}[chunkId] + ".chunk.css";
};